import { useEffect } from 'react';
import { hapticFeedback } from '@telegram-apps/sdk-react';

export function useFormErrors(errors, submitCount, fieldRefs) {
  useEffect(() => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length === 0) return;
    const firstErrorField = errorKeys[0];
    const fieldRef = fieldRefs[firstErrorField];

    if (fieldRef && fieldRef.current) {
      fieldRef.current.focus();
      hapticFeedback.notificationOccurred('error');

      fieldRef.current.scrollIntoView({
        inline: 'center',
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [errors, fieldRefs, submitCount]);
}
